__turbopack_context__.v({
  "colourFilterDropdownContents": "styles-module__KTfy-a__colourFilterDropdownContents",
  "colourFilterDropdownOptionContainer": "styles-module__KTfy-a__colourFilterDropdownOptionContainer",
  "colourFilterDropdownOptionLabel": "styles-module__KTfy-a__colourFilterDropdownOptionLabel",
});
